import { drawChevron } from "@gameApp/helpers/canvas/draw/drawChevron";
import { drawRoundRect } from "@gameApp/helpers/canvas/draw/rectRounded";
import { drawTextPure } from "@gameApp/helpers/canvas/draw/textPure";
import { getContextFont } from "@gameApp/helpers/canvas/getContextFont";
import { measureText } from "@gameApp/helpers/canvas/measureText";
import {
  BASE_FONT_SIZE,
  BLOCK_BORDER_RADIUS,
  BLOCK_HEIGHT,
  BLOCK_HORIZONTAL_PADDING,
} from "@gameComponents/MiniGame/OrderOverview/Snapshot/constants";
import colors from "tailwindcss/colors";

interface Params {
  context: CanvasRenderingContext2D;
  x: number;
  y: number;
  width: number;
  label: string;
  value: string;
  initialY: number;
  chevronDirection: "up" | "down";
  chevronColor: string;
}

const CHEVRON_DIMENSIONS = { width: 8, height: 5 };
const CHEVRON_MARGIN = 2;
const BOLD_TEXT_OPTIONS = { size: BASE_FONT_SIZE, weight: 700 };
const DEFAULT_TEXT_OPTIONS = { size: BASE_FONT_SIZE, weight: 500 };

export function miniGameOrderOverviewSnapshotDrawUserWinRate(
  params: Params,
): void {
  const {
    context,
    x,
    y,
    width,
    label,
    value,
    initialY,
    chevronDirection,
    chevronColor,
  } = params;
  context.fillStyle = colors.gray[900];
  drawRoundRect({
    context,
    x,
    y,
    width,
    height: BLOCK_HEIGHT,
    radius: BLOCK_BORDER_RADIUS,
    stroke: false,
  });

  drawTextPure({
    context,
    text: value,
    x: x + BLOCK_HORIZONTAL_PADDING,
    y: initialY,
    contextOptions: {
      font: getContextFont(BOLD_TEXT_OPTIONS),
      fillStyle: colors.white,
    },
  });

  const { width: valueWidth } = measureText(value, (ctx) => {
    ctx.font = getContextFont(BOLD_TEXT_OPTIONS);
  });

  drawChevron({
    context,
    x:
      x +
      BLOCK_HORIZONTAL_PADDING +
      valueWidth +
      CHEVRON_DIMENSIONS.width +
      CHEVRON_MARGIN,
    y: initialY - CHEVRON_DIMENSIONS.height,
    width: CHEVRON_DIMENSIONS.width,
    height: CHEVRON_DIMENSIONS.height,
    direction: chevronDirection,
    contextOptions: {
      lineWidth: 2,
      strokeStyle: chevronColor,
      lineJoin: "round",
      lineCap: "round",
    },
  });

  drawTextPure({
    context,
    text: label,
    x: x + BLOCK_HORIZONTAL_PADDING,
    y: initialY + 22,
    contextOptions: {
      font: getContextFont(DEFAULT_TEXT_OPTIONS),
      fillStyle: colors.gray[400],
    },
  });
}
